import React, { FC } from "react";
import {useTypedSelector} from "../reducers";
import logo from "../assets/images/shine/header_logo_white.svg";

interface UrlInfo {
    name: string;
    url: string;
}

interface SiteGroup {
    grpName: string;
    sites: UrlInfo[];
}

const ShineFooter = () => {
    const { site } = useTypedSelector(state => state.profile);

    const siteGroup: SiteGroup[] = [
        { grpName: 'Related Sites',
            sites: [
                { name: '보건복지부', url: 'http://www.mohw.go.kr/' },
                { name: '보건의료정보원', url: 'https://www.k-his.or.kr/' },
                { name: '공공데이터포털', url: 'https://www.data.go.kr/' },
                { name: '보건의료 빅데이터 플랫폼', url: 'https://hcdl.mohw.go.kr/' },
            ]
        }
    ];

    return (
        <div className="shine-footer-wrapper">
            <div className="shine-footer">
                <div>
                    <div className="shine-footer-logo">
                        <img src={logo} />
                    </div>
                    <div className="shine-footer-contact">contact@shine.re.kr</div>
                    <div className="shine-footer-copyright">COPYRIGHT©By SHiNE. All rights Reserved</div>
                </div>
                <div className={'footer-site-wrapper'}>
                    { siteGroup.map( (group: SiteGroup, idx: number) => {
                        return (
                            <div key={idx} className={'footer-site-button flex-center'}>
                                {group.grpName}
                                <div className={'footer-site-group'}>
                                    { group.sites.map( (site: UrlInfo, idx: number) => {
                                        return (
                                            <a href={site.url} target={'_blank'} key={idx}>
                                                <div className={'footer-site'}>{site.name}</div>
                                            </a>
                                        );
                                    })}
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
}

export default ShineFooter;
